/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Response_P1Inputs */

const en_contact_response_p1 = /** @type {(inputs: Contact_Response_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is maintained by one person alongside a day job, so replies can take a little longer during busy weeks. If your message is time sensitive, say so in the subject line and I will do my best to prioritize it.`)
};

const ko_contact_response_p1 = /** @type {(inputs: Contact_Response_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 본업과 병행해 한 사람이 운영합니다. 바쁜 주에는 답장이 늦어질 수 있습니다. 급한 내용이면 제목에 그렇게 적어주세요. 최대한 먼저 처리하겠습니다.`)
};

const ja_contact_response_p1 = /** @type {(inputs: Contact_Response_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON は本業と並行して 1 人で運営しています。忙しい週は返信が遅れることがあります。お急ぎの場合は件名にそう書いてください。できるだけ優先して対応します。`)
};

/**
* | output |
* | --- |
* | "PureJSON is maintained by one person alongside a day job, so replies can take a little longer during busy weeks. If your message is time sensitive, say so in..." |
*
* @param {Contact_Response_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_response_p1 = /** @type {((inputs?: Contact_Response_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Response_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_response_p1(inputs)
	if (locale === "ko") return ko_contact_response_p1(inputs)
	return ja_contact_response_p1(inputs)
});